import { Organization, UpdateOrganization } from 'core/types';
import { useReducer } from 'react';
import { createContainer } from 'unstated-next';
import { updateOrganization } from './query';

interface Action {
  type: 'fetched' | 'updated';
}

interface Fetched extends Action {
  type: 'fetched';
  data: Organization;
}

interface Updated extends Action {
  type: 'updated';
  data: Organization;
}

type Actions = Fetched | Updated;

function reducer(state: Organization, action: Actions): Organization {
  switch (action.type) {
    case 'fetched':
    case 'updated':
      return action.data;
    default:
      return state;
  }
}

interface Dispatch {
  fetched: (data: Organization) => void;
  updateOrganization: (draft: UpdateOrganization) => Promise<boolean>;
}

const emptyOrganization = (): Organization => ({
  id: '',
  name: '',
  roles: [],
});

function useOrganizationReducer(
  initialState?: Organization,
): [Organization, Dispatch] {
  const [state, dispatch] = useReducer(
    reducer,
    initialState || emptyOrganization(),
  );

  const dispatcher: Dispatch = {
    fetched: data => {
      dispatch({ type: 'fetched', data });
    },
    updateOrganization: async draft => {
      try {
        const data = await updateOrganization(draft);
        dispatch({ type: 'updated', data });
        return true;
      } catch (e) {
        // TODO: report error somehow
        return false;
      }
    },
  };

  return [state, dispatcher];
}

const container = createContainer<[Organization, Dispatch], Organization>(
  useOrganizationReducer,
);
const useOrganization = container.useContainer;
export const OrganizationProvider = container.Provider;
export default useOrganization;
